import { Routes } from '@angular/router';
import { MonCompteComponent } from './mon-compte.component';

export const MON_COMPTE_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'or',
        pathMatch: 'full'
    },
    {
        path: 'or',
        component: MonCompteComponent,
        data: {
            title: 'page.mon-compte.title.organisme'
        }
    }
];
